export default {
    setIsDark (context, payload) {
        context.commit('setIsDark', payload)
    },
    setFusionAuthToken (context, payload) {
        context.commit('setFusionAuthToken', payload)
    }
}
